
export const IMAGE_TYPES = ["jpeg", "jpg", "png"];
export const VIDEO_TYPES = ["mp4", "avi", "mov"];